var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"column main-color-bg",attrs:{"id":"FooterModules"}},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"has-text-white-ter"},[_vm._v(" "+_vm._s(_vm.$t("copy"))+" "),_vm._m(0)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('u',[_c('a',{staticClass:"has-text-white",attrs:{"href":"mailto:info@ceptinel.com"}},[_vm._v(" info@ceptinel.com ")])])
}]

export { render, staticRenderFns }